import { render, staticRenderFns } from "./carDetailCoupon.vue?vue&type=template&id=cfd83ad2"
import script from "./carDetailCoupon.vue?vue&type=script&lang=js"
export * from "./carDetailCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports